<template>
    <div class="apprentice-simple-card">
        <div class="rating-forms-sections">
            <design-2021-rating-tab-rating-section-component
                v-for="(section, sectionindex) in ratingIn.sections"
                :key="section.id"
                :section-in="section"
                :section-index="sectionindex"
                :rating-in="ratingIn"
                :users-in="usersIn"
                @save-form="saveForm">
            </design-2021-rating-tab-rating-section-component>
        </div>

        <!--        <b-card no-body class="rating-card" v-for="(section, sectionindex) in ratingIn.sections" :key="section.id">-->
        <!--            <b-card-header header-tag="header" class="rating-card-header" role="tab">-->
        <!--                <b-button block v-b-toggle="`ratings-section-${section.id}`" variant="primary" class="btn-rating-card-header-toggler">-->
        <!--                    {{String.fromCharCode(sectionindex+65)}}. {{section.title}}-->
        <!--                    <span class="section-grade" v-if="!section.personal && section.type == 1">-->
        <!--                        {{getSectionGrade(section.id)}} pt-->
        <!--                    </span>-->
        <!--                </b-button>-->
        <!--            </b-card-header>-->
        <!--            <b-collapse :id="`ratings-section-${section.id}`" :visible="sectionindex === 0" accordion="ratings-section" role="tabpanel">-->
        <!--                <b-card-body body-tag="div">-->
        <!--                    <design-2021-apprentice-display-html-component class="rating-description muted-text" v-if="section.description" :html-content="section.description" text-tag="div">-->
        <!--                    </design-2021-apprentice-display-html-component>-->
        <!--                    <div class="personal-body" v-if="section.personal">-->
        <!--                        <div class="personal-content" v-for="user in usersIn">-->
        <!--                            <div class="personal-header">-->
        <!--                                <h4 class="person-name">-->
        <!--                                    <i class="fas fa-fw fa-user"></i>-->
        <!--                                    {{user.full_name}}-->
        <!--                                </h4>-->
        <!--                                <span v-if="section.type == 1">-->
        <!--                                    {{getSectionUserGrade(section.id, user.id)}} pt-->
        <!--                                </span>-->
        <!--                            </div>-->
        <!--                            <div class="personal-item-content" v-for="(item, itemindex) in section.items"-->
        <!--                                 :key="item.id">-->
        <!--                                <div class="personal-item-header">-->
        <!--                                    <h5 class="item-title">-->
        <!--                                        {{itemindex+1}}. {{item.title}}-->
        <!--                                    </h5>-->
        <!--                                    <span class="item-max-and-weight" :title="'Max '+item.max+' punten; Weging '+item.weight" v-if="item.type === 1">-->
        <!--                                        <div class="max">-->
        <!--                                           <i class="fa fa-trophy" style="line-height: 1.3; padding-right: 3px;"></i>{{item.max}}-->
        <!--                                        </div>-->
        <!--                                        <div class="weight">-->
        <!--                                            <i class="fa fa-weight-hanging" style="line-height: 1.3; padding-left: 10px; padding-right: 3px;"></i>{{item.weight}}-->
        <!--                                        </div>-->

        <!--                                    </span>-->
        <!--                                    <span class="item-weight" :title="'Weging '+item.weight" v-if="item.type === 2">-->
        <!--                                        <i class="fa fa-weight-hanging" style="line-height: 1.3; padding-right: 3px;"></i> {{item.weight}}-->
        <!--                                    </span>-->
        <!--                                </div>-->
        <!--                                <design-2021-apprentice-display-html-component class="item-description muted-text" v-if="item.description" :html-content="item.description"></design-2021-apprentice-display-html-component>-->
        <!--                                <div class="item-input" v-if="item.type === 1">-->
        <!--                                    <design-2021-rating-answer-component :item-in="item" :rating-form-id="ratingIn.forms[0].id" @updateOpenAnswer="onOpenAnswerUser($event, item, user.id)" :user-in="user.id"></design-2021-rating-answer-component>-->
        <!--                                </div>-->
        <!--                                <div class="item-options" v-if="item.type === 2">-->
        <!--                                    <design-2021-rating-answer-option-component :item-in="item" :rating-form-id="ratingIn.forms[0].id" :section-in="section" @updateClosedAnswer="onClosedAnswerUser($event, item, user.id)" :user-in="user"></design-2021-rating-answer-option-component>-->
        <!--                                </div>-->
        <!--                            </div>-->
        <!--                        </div>-->
        <!--                    </div>-->
        <!--                    <div class="rating-body rating-item-body" v-else>-->
        <!--                        <div class="rating-item-content" v-for="(item, itemindex) in section.items" :key="item.id">-->
        <!--                            <div class="rating-item-header">-->
        <!--                                <h5 class="rating-item-title">-->
        <!--                                    {{itemindex+1}}. {{item.title}}-->
        <!--                                </h5>-->
        <!--                                <span class="item-max-and-weight" :title="'Max '+item.max+' punten; Weging '+item.weight" v-if="item.type === 1">-->
        <!--                                    <div class="max">-->
        <!--                                        <i class="fa fa-trophy" style="line-height: 1.3; padding-right: 3px;"></i> Max: {{item.max}}-->
        <!--                                    </div>-->
        <!--                                    <div class="weight">-->
        <!--                                        <i class="fa fa-weight-hanging" style="line-height: 1.3; padding-left: 10px; padding-right: 3px;"></i> {{item.weight}}-->
        <!--                                    </div>-->
        <!--                                </span>-->
        <!--                                <span class="item-weight" :title="'Weging '+item.weight" v-if="item.type === 2">-->
        <!--                                    <i class="fa fa-weight-hanging" style="line-height: 1.3; padding-right: 3px;"></i> {{item.weight}}-->
        <!--                                </span>-->
        <!--                            </div>-->
        <!--                            <design-2021-apprentice-display-html-component class="rating-item-description muted-text" v-if="item.description" :html-content="item.description"></design-2021-apprentice-display-html-component>-->
        <!--                            <div class="rating-item-input" v-if="item.type === 1">-->
        <!--                                <design-2021-rating-answer-component :item-in="item" :rating-form-id="ratingIn.forms[0].id" @updateOpenAnswer="onOpenAnswer($event, item)"></design-2021-rating-answer-component>-->
        <!--                            </div>-->
        <!--                            <div class="rating-item-options" v-if="item.type === 2">-->
        <!--                                <design-2021-rating-answer-option-component :item-in="item" :rating-form-id="ratingIn.forms[0].id" :section-in="section" @updateClosedAnswer="onClosedAnswer($event, item)"></design-2021-rating-answer-option-component>-->
        <!--                            </div>-->
        <!--                        </div>-->
        <!--                    </div>-->

        <!--                </b-card-body>-->
        <!--            </b-collapse>-->
        <!--        </b-card>-->

        <div
            class="retraction-points"
            v-if="ratingIn.result_penalty">
            <b-form-group :label="$t('rating.negative_points')">
                <b-form-input
                    class="form-control penalty-evaluate-points"
                    v-model="penalty"
                    step="0.1"
                    min="0.0"
                    :disabled="isStudent"
                    type="number"
                    :placeholder="$t('rating.negative_points')"
                    :no-wheel="true">
                </b-form-input>
            </b-form-group>
        </div>

        <div
            class="explanation-score"
            v-if="ratingIn.result_explanation">
            <b-form-group :label="$t('rating.explanation_on_score')">
                <div
                    class="rating-result-explanation"
                    id="rating-result-explanation">
                    <ckeditor
                        v-model="explanation"
                        :editor="editor"
                        :config="editorConfig"
                        :disabled="isStudent">
                    </ckeditor>
                </div>
            </b-form-group>
        </div>

        <div
            class="rating-form-actions"
            v-if="!isStudent">
            <b-button
                class="btn-save btn-rating-save"
                variant="primary"
                @click="saveForm">
                {{ $t('common.save') }}
            </b-button>
            <b-button
                class="btn-download btn-rating-download"
                variant="primary"
                :href="routes.ratingDownload(ratingIn.id, projectId)"
                >{{ $t('common.download') }}
            </b-button>
        </div>

        <div v-if="hasGrades()">
            <div
                class="personal-score-total"
                v-if="hasPersonalSections()">
                <div
                    class="student"
                    v-for="user in usersIn"
                    v-if="user.type == 'student'">
                    <b-list-group>
                        <b-list-group-item>
                            <div class="student-credentials">
                                <span class="label">{{ $t('rating.student') }}</span>
                                <span class="name">{{ user.full_name }}</span>
                            </div>
                        </b-list-group-item>

                        <b-list-group-item>
                            <div class="student-points">
                                <span class="label">{{ $t('rating.points') }}</span>
                                <span class="total-points">{{ totalPointsUser(user.id) }}</span>
                            </div>
                        </b-list-group-item>

                        <b-list-group-item>
                            <div class="student-grade">
                                <span class="label">{{ $t('rating.grade') }}</span>
                                <span class="grade-total">{{ gradeUser(user.id) }}</span>
                            </div>
                        </b-list-group-item>
                    </b-list-group>
                </div>
            </div>
            <div
                class="score-total"
                v-else>
                <b-list-group>
                    <b-list-group-item>
                        <div class="points">
                            <span class="label">{{ $t('rating.points') }}</span>
                            <span class="total-points">{{ totalPoints() }}</span>
                        </div>
                    </b-list-group-item>

                    <b-list-group-item>
                        <div class="grade">
                            <span class="label">{{ $t('rating.grade') }}</span>
                            <span class="grade-total">{{ grade() }}</span>
                        </div>
                    </b-list-group-item>
                </b-list-group>
            </div>
        </div>
    </div>
</template>

<script>
import ApprenticeEditor from '../../helpers/ApprenticeEditor';

export default {
    name: 'design-2021-rating-tab-component',
    props: ['ratingIn', 'projectId', 'usersIn'],
    data() {
        return {
            isStudent: !!AuthIsStudent,
            editor: ApprenticeEditor,
            editorConfig: {
                contentsCss: 'test',
                bodyClass: 'mybodyclass',
                toolbar: {
                    items: [
                        'heading',
                        '|',
                        'bold',
                        'italic',
                        'underline',
                        '|',
                        'link',
                        'bulletedList',
                        'numberedList',
                        'undo',
                        'redo',
                    ],
                },
                language: this.$authUser.locale,
                table: {
                    contentToolbar: ['tableColumn', 'tableRow', 'mergeTableCells'],
                },
            },
            explanation: this.ratingIn.forms[0].explanation ? this.ratingIn.forms[0].explanation : '',
        };
    },
    watch: {
        ratingIn: function (value) {
            this.explanation = value.forms[0].explanation ? value.forms[0].explanation : '';
        },
    },
    methods: {
        hasPersonalSections() {
            let found = false;

            this.ratingIn.sections.forEach(function (section, key) {
                if (section.personal == 1) {
                    found = true;
                }
            });

            return found;
        },
        hasGrades() {
            let found = false;

            this.ratingIn.sections.forEach(function (section, key) {
                if (section.type == 1) {
                    found = true;
                }
            });

            return found;
        },
        onOpenAnswerUser(value, item, user_id) {
            let found = false;
            item.answers.forEach(function (answer) {
                if (answer.user_id == user_id) {
                    found = true;
                    answer.open_answer = value;
                }
            });

            if (!found) {
                item.answers.push({
                    open_answer: value,
                    user_id: user_id,
                    rating_form_id: this.ratingIn.forms[0].id,
                });
            }
        },
        onOpenAnswer(value, item) {
            item.answers = [];
            item.answers[0] = {};
            item.answers[0].rating_form_id = this.ratingIn.forms[0].id;
            item.answers[0].open_answer = value;
        },
        onClosedAnswer(value, item) {
            item.answers = [];
            item.answers[0] = {};
            item.answers[0].rating_form_id = this.ratingIn.forms[0].id;
            item.answers[0].rating_option_id = value;
        },
        onClosedAnswerUser(value, item, user_id) {
            let found = false;
            item.answers.forEach(function (answer) {
                if (answer.user_id == user_id) {
                    found = true;
                    answer.rating_option_id = value;
                }
            });

            if (!found) {
                item.answers.push({
                    rating_option_id: value,
                    user_id: user_id,
                    rating_form_id: this.ratingIn.forms[0].id,
                });
            }
        },
        totalPointsUser(user_id) {
            return Math.round(this.totalNotRoundedPointsUser(user_id));
        },
        totalNotRoundedPointsUser(user_id) {
            let total = 0;
            const self = this;

            this.ratingIn.sections.forEach(function (section, key) {
                if (section.type == 1) {
                    section.items.forEach(function (item, key2) {
                        if (item.type == 1) {
                            if (item.answers.length) {
                                if (section.personal == 1) {
                                    item.answers.forEach(function (answer, key4) {
                                        if (
                                            answer.user_id == user_id &&
                                            answer.rating_form_id === self.ratingIn.forms[0].id
                                        ) {
                                            total += item.weight * answer.open_answer;
                                        }
                                    });
                                } else {
                                    total += item.weight * item.answers[0].open_answer;
                                }
                            }
                        } else {
                            if (item.answers.length) {
                                if (section.personal == 1) {
                                    item.answers.forEach(function (answer, key5) {
                                        item.options.forEach(function (option, key3) {
                                            if (
                                                option.id == answer.rating_option_id &&
                                                answer.user_id == user_id &&
                                                answer.rating_form_id === self.ratingIn.forms[0].id
                                            ) {
                                                total += item.weight * option.max;
                                            }
                                        });
                                    });
                                } else {
                                    item.options.forEach(function (option, key3) {
                                        if (option.id == item.answers[0].rating_option_id) {
                                            total += item.weight * option.max;
                                        }
                                    });
                                }
                            }
                        }
                    });
                }
            });

            return total;
        },
        totalPoints() {
            return Math.round(this.totalNotRoundedPoints());
        },
        totalNotRoundedPoints() {
            let total = 0;

            for (const section of this.ratingIn.sections) {
                if (section.type !== 1) {
                    continue;
                }

                itemLoop: for (const item of section.items) {
                    if (item.type === 1) {
                        for (const answer of item.answers) {
                            if (answer.rating_form_id === this.ratingIn.forms[0].id) {
                                total += item.weight * answer.open_answer;
                                continue itemLoop;
                            }
                        }
                    } else {
                        for (const answer of item.answers) {
                            if (answer.rating_form_id === this.ratingIn.forms[0].id) {
                                for (const option of item.options) {
                                    if (option.id === answer.rating_option_id) {
                                        total += item.weight * option.max;
                                        continue itemLoop;
                                    }
                                }
                            }
                        }
                    }
                }
            }

            return total;
        },
        grade() {
            let grade = this.totalNotRoundedPoints() / this.ratingIn.result_divide + this.ratingIn.result_plus;

            let penalty = parseFloat(this.ratingIn.forms[0].penalty);
            if (isNaN(penalty)) penalty = 0;

            grade = grade - penalty;

            return Math.round(grade * 10) / 10;
        },
        gradeUser(user_id) {
            let grade =
                this.totalNotRoundedPointsUser(user_id) / this.ratingIn.result_divide + this.ratingIn.result_plus;

            let penalty = parseFloat(this.ratingIn.forms[0].penalty);
            if (isNaN(penalty)) penalty = 0;

            grade = grade - penalty;

            return Math.round(grade * 10) / 10;
        },
        getSectionGrade(section_id) {
            let total = 0;

            for (const section of this.ratingIn.sections) {
                if (section.id !== section_id) {
                    continue;
                }

                itemLoop: for (const item of section.items) {
                    if (item.type === 1) {
                        for (const answer of item.answers) {
                            if (answer.rating_form_id === this.ratingIn.forms[0].id) {
                                total += item.weight * answer.open_answer;
                                continue itemLoop;
                            }
                        }
                    } else {
                        for (const answer of item.answers) {
                            if (answer.rating_form_id === this.ratingIn.forms[0].id) {
                                for (const option of item.options) {
                                    if (option.id === answer.rating_option_id) {
                                        total += item.weight * option.max;
                                        continue itemLoop;
                                    }
                                }
                            }
                        }
                    }
                }
            }

            return Math.round(total * 10) / 10;
        },
        getSectionUserGrade(section_id, user_id) {
            let total = 0;
            const self = this;
            this.ratingIn.sections.forEach(function (section, key) {
                if (section.id === section_id) {
                    section.items.forEach(function (item, key2) {
                        if (item.type === 1) {
                            if (item.answers.length) {
                                if (section.personal === 1) {
                                    item.answers.forEach(function (answer, key4) {
                                        if (
                                            answer.user_id === user_id &&
                                            answer.rating_form_id === self.ratingIn.forms[0].id
                                        ) {
                                            total += item.weight * answer.open_answer;
                                        }
                                    });
                                } else {
                                    total += item.weight * item.answers[0].open_answer;
                                }
                            }
                        } else {
                            if (item.answers.length) {
                                if (section.personal === 1) {
                                    item.answers.forEach(function (answer, key5) {
                                        item.options.forEach(function (option, key3) {
                                            if (
                                                option.id === answer.rating_option_id &&
                                                answer.user_id === user_id &&
                                                answer.rating_form_id === self.ratingIn.forms[0].id
                                            ) {
                                                total += item.weight * option.max;
                                            }
                                        });
                                    });
                                } else {
                                    item.options.forEach(function (option, key3) {
                                        if (option.id == item.answers[0].rating_option_id) {
                                            total += item.weight * option.max;
                                        }
                                    });
                                }
                            }
                        }
                    });
                }
            });

            return Math.round(total * 10) / 10;
        },
        selectOption(item, option_id) {
            item.answers[0].rating_option_id = option_id;
        },
        saveForm() {
            if (this.foundErrors()) {
                this.alert.error(
                    this.$t('rating.form_not_sent'),
                    this.$t('rating.not_all_fields_filled_in_correctly_please_check_the_form_and_try_again'),
                );
                return;
            }
            this.alert.saving();

            const data = {
                rating: this.ratingIn,
                project_id: this.projectId,
                form_id: this.ratingIn.forms[0].id,
            };

            data.rating.forms[0].explanation = this.explanation;

            this.axios.post(this.routes.ratingProjectSave(), data).then(
                (response) => {
                    this.alert.success();
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
        foundErrors() {
            for (const section of this.ratingIn.sections) {
                for (const item of section.items) {
                    for (const answer of item.answers) {
                        if (answer.open_answer !== null && parseFloat(answer.open_answer) > parseFloat(item.max)) {
                            return true;
                        }
                    }
                }
            }
            return false;
        },
    },
    computed: {
        penalty: {
            get: function () {
                return this.ratingIn.forms[0].penalty;
            },
            set: function (value) {
                value = value.toString().replace(',', '.');
                this.ratingIn.forms[0].penalty = value;

                return value;
            },
        },
    },
};
</script>

<style scoped lang="scss">
.rating-forms-sections {
    margin-bottom: map-get($grid-gutter-spacing, 'forty-two');
    padding-bottom: map-get($grid-gutter-spacing, 'forty-two');
    border-bottom: 1px solid $border-color;
}

.rating-form-actions {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
    margin-top: map-get($grid-gutter-spacing, 'forty-two');
    margin-bottom: map-get($grid-gutter-spacing, 'forty-two');

    .btn {
        &:not(:last-child) {
            margin-right: $grid-gutter-width;
        }
    }
}

input.penalty-evaluate-points::-webkit-outer-spin-button,
input.penalty-evaluate-points::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

input.penalty-evaluate-points[type='number'] {
    -moz-appearance: textfield;
}

.personal-score-total,
.score-total {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
    grid-gap: 0.5rem;
    align-items: flex-start;
    margin-top: map-get($grid-gutter-spacing, 'twenty-one') * 2;

    .list-group-item {
        border: none;
        padding: map-get($grid-gutter-spacing, 'eight') map-get($grid-gutter-spacing, 'twenty-one');
    }

    .student {
        margin-bottom: map-get($grid-gutter-spacing, 'twenty-one');
        display: grid;
        grid-template-rows: auto;
        grid-gap: 0.5rem;
    }

    .label {
        font-weight: $font-weight-bold;
    }
}

.student-credentials,
.student-points,
.student-grade,
.points,
.grade {
    display: flex;
    align-items: center;
    justify-content: space-between;
}
</style>
